import Box from "@material-ui/core/Box";
import React from "react";
import { usePermissions } from "react-admin";

import { documentTypes } from "../../../entities/documentTypes";
import { DownloadAllControl } from "./components/DownloadAllControl";
import { DocumentsDialogs } from "./components/DocumentsDialogs";
import { DocumentsList } from "./components/DocumentsList";
import { DropPaper } from "./DropPaper";
import { useDocumentMutation } from "./hooks/useDocumentMutation";
import { useDocuments } from "./hooks/useDocuments";
import { useEntityFileUpload } from "./hooks/useEntityFileUpload";
import { useOutputDocumentStatus } from "./hooks/useOutputDocumentStatus";

import { UploadControls } from "./components/UploadControls";

export const DocumentsField = ({
	typeChoices,
	disabled,
	footerContent,
	isTypeShow,
	isTypeRequired,
	showDownloadAll = false,
	hideEditDialog,
	onDataChange,
	defaultDocumentType = "",
	...props
}) => {
	const { permissions } = usePermissions();
	const documentsPath = props.isOutputDocuments ? "documents-output" : "documents";

	const { data, loading, fetchAllDocuments } = useDocuments(
		props.resource,
		props.record.id,
		documentsPath,
		onDataChange
	);

	const [uploading, uploadFile, uploaded, resetUploaded] = useEntityFileUpload(
		fetchAllDocuments,
		props.record.id,
		props.resource
	);
	const { deleteDocument, updateDocument } = useDocumentMutation(
		props.resource,
		props.record.id,
		documentsPath,
		fetchAllDocuments
	);

	useOutputDocumentStatus(
		data,
		props.isOutputDocuments,
		props.changeIsLoading,
		props.changeIsUnloading
	);

	const currentChoices = typeChoices || documentTypes;
	const uploadedDocumentFromData = data?.find?.((document) => document.id === uploaded?.id);
	const uploadedDocument = uploadedDocumentFromData ? { ...uploaded, ...uploadedDocumentFromData } : uploaded;
	const [selectedType, setSelectedType] = React.useState(defaultDocumentType);
	const [typeSelectionAttempted, setTypeSelectionAttempted] = React.useState(false);



	if (!permissions) return null;

	// const isIsExternalNotApproved = isExternalNotApproved(props.record.state);

	return (
		<DropPaper
			draggable={!disabled && !uploading}
			uploading={uploading}
			processDocument={(file) => {
				if (isTypeRequired && !selectedType) {
					setTypeSelectionAttempted(true);
					return;
				}
				uploadFile(file, { type: selectedType });
			}}
			elevation={0}
			variant={props.variant || "outlined"}
		>
			<DocumentsDialogs
				uploaded={uploadedDocument}
				hideEditDialog={hideEditDialog}
				resetUploaded={resetUploaded}
				updateDocument={updateDocument}
				typeChoices={currentChoices}
			/>

			{/* {!props.isOutputDocuments & !isIsExternalNotApproved && ( */}
			{!props.isOutputDocuments && (
				<>
					<Box px={2} pt={1} display="flex" alignItems="center" justifyContent="flex-start">
						<Box>
								<UploadControls
									disabled={disabled}
									uploading={uploading}
									isTypeShow={isTypeShow}
									isTypeRequired={isTypeRequired}
									selectedType={selectedType}
									setSelectedType={setSelectedType}
									typeSelectionAttempted={typeSelectionAttempted}
									setTypeSelectionAttempted={setTypeSelectionAttempted}
									currentChoices={currentChoices}
									uploadFile={uploadFile}
								/>
						</Box>
						{showDownloadAll && (
							<Box>
									<DownloadAllControl
										recordId={props.record.id}
										disabled={disabled || uploading}
										documentsCount={data?.length || 0}
									/>
							</Box>
						)}
					</Box>
				</>
			)}
			<Box p={2}>
				<DocumentsList
					loading={loading}
					data={data}
					isOutputDocuments={props.isOutputDocuments}
					footerContent={footerContent}
					disabled={disabled}
					isCustomerAsTrans={props.isCustomerAsTrans}
					permissions={permissions}
					record={props.record}
					handleDelete={deleteDocument}
					handleUpdate={updateDocument}
					resource={props.resource}
					typeChoices={currentChoices}
				/>
			</Box>
		</DropPaper>
	);
};

export const DocumentsFieldBlock = (props) => <DocumentsField {...props} />;
